<template>
    <div class="body-panel news">
        <div class="body-panel-control separator" v-if="info.User && (info.User.MainRole === 'administrators' || info.ProjectsLength > 1 || hasClaims(info.User.DynamicRole, claimEnums.newsCreate))">
            <div class="control-block-left" v-if="(info.User.MainRole === 'administrators' || info.ProjectsLength > 1)">
                <project-select :user="info.User" @onChange="onProjectChange"></project-select>
            </div>
            <div class="control-block-right" v-if="hasClaims(info.User.DynamicRole, claimEnums.newsCreate) || info.User.MainRole === 'administrators'">
                <button class="btn btn-news" @click="onAddNews()">Добавить новость</button>
            </div>
        </div>
        <div class="body-panel-content body-panel-content-page panel-block-news no-padding-right">
            <div class="body-panel-content-center">
                <div  v-for="(item, i) of news" :class="['panel-block', 'panel-block-new', { 'disabled': item.DateExpired }, {'not-read': !item.ReadByUser} ]" @click="goToNews(item.Id)">
                    <div class="panel-block-img-base">
                        <div class="panel-block-img">
                            <img :src="item.Image" alt="" :style="getImageStyleFormatted(item.ImageStyle)" />
                        </div>
                    </div>
                    <div class="panel-block-info">
                            <p class="panel-block-header margin-bottom-10">{{ item.Title }}</p>
                            <p class="panel-body-desc" v-html="item.PreviewFormatted"></p>
                    </div>
                    <div class="panel-body-actions">
                        <button class="btn" @click="goToNews(item.Id)">Читать</button>
                        <button class="btn margin-left-10 btn-img" @click.stop="goToEditNews(item.Id)" v-if="item.Id > 0 && info.User && (hasClaims(info.User.DynamicRole, claimEnums.newsCreate) || info.User.MainRole === 'administrators')"><img src="../../img/pencil-edit-button.png" alt="" /></button>
                        <span class="panel-body-actions-date">{{ item.StartDate | date-short }}</span>

                    </div>
                    <div class="panel-body-stats" v-if="item.LikesEnabled || item.CommentsEnabled || item.DisplayViews">
                        <p v-if="item.LikesEnabled" :class="['news-actions like', {'bold': item.MyVote === true}]" @click.stop="onMakeMark(item, i)" title="Нравится">
                            <svg class="svg-icon like-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <use xlink:href="/Content/dist/image_svg.svg#Like"></use>
                            </svg>
                            <svg class="svg-icon like-2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <use xlink:href="/Content/dist/image_svg.svg#Like2"></use>
                            </svg>
                            <span style="font-weight:400;line-height:1.3">{{item.LikesCount}}</span>
                        </p>
                        <p v-if="item.CommentsEnabled" @click.stop="$router.push('/news/' + item.Id + '?comments')" class="news-actions" title="Обсудить">
                            <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <use xlink:href="/Content/dist/image_svg.svg#Comm"></use>
                            </svg>
                            <span style="font-weight:400;line-height:1.3">
                                {{item.CommentsCount}}
                            </span>
                        </p>
                        
                    </div>
                </div>
            </div>
        </div>
        <vue-headful :title="getPageTitle()" />
    </div>
</template>

<script>
    import $ from 'jquery'
    import UI from '../helpers/ui-helpers'
    import BackendApi from '../backendApi'
    import projectMixin from '../helpers/project-mixin'
    import claimsCheckingMixin from '../helpers/claims-checking-mixin'
    import Vue from 'vue'

    let backendApi = new BackendApi();
    let cacheKey = 'newsState';

    export default {
        name: "news",

        mixins: [projectMixin, claimsCheckingMixin], // projectId

        data(){
            return{
                news: [],
                loading: false,
                canBeLoaded: true,
                page: 1,
                projectId: null,
                rowsPerPage: 20,
                scrollTop: null,
                firstLoad: true
            }
        },

        methods: {
            onMakeMark(newsItem, index) {
                let vm = this;

                backendApi.newsMakeVote(newsItem.Id).then(function (response) {
                    if (response.hasError) {
                        UI.toastr.error('Ошибка при выполнении запроса. Попробуйте позже');
                    } else {
                        newsItem.MyVote = !newsItem.MyVote;
                        if(newsItem.MyVote){
                            newsItem.LikesCount++;
                        }
                        else {
                            newsItem.LikesCount--;
                        }

                        Vue.set(vm.news, index, newsItem);
                    }
                });
            },

            getImageStyleFormatted(imageStyle){
                if(!imageStyle){
                    return null;
                }

                let settings = {
                    left: imageStyle.left + '%',
                    top: imageStyle.top + '%',
                    transform: 'translateY(' + imageStyle.translateY + '%) translateX(' +
                    imageStyle.translateX + '%)'
                };
                if(imageStyle.resizeType === 1 && parseInt(imageStyle.size)){
                    settings.height = imageStyle.size + '%';
                }
                if(imageStyle.resizeType === 2 && parseInt(imageStyle.size)){
                    settings.width = imageStyle.size + '%';
                }
                return settings;
            },

            loadNext(){
                let vm = this;
                this.loading = true;
                UI.blockUI('.news', 'Загрузка...');

                let skip = (vm.page - 1) * vm.rowsPerPage;
                let take = vm.rowsPerPage;
                if (vm.firstLoad && vm.page > 1) {
                    skip = 0;
                    take = vm.page * vm.rowsPerPage;
                }

                this.callApiWrapper(backendApi.newsList(skip, take, vm.projectId))
                    .then(function (resp) {
                    if(resp.hasError && resp.status !== 401) {
                        UI.toastr.error('Ошибка во время загрузки новостей');
                    }
                    else{
                        if(resp.data && resp.data.length){
                            for(let item of resp.data){
                                item.PreviewFormatted = item.Preview ? UI.format_text_helper(UI.format_text_to_url(item.Preview.replace(/\n/g, '<br>'))) : null;
                                if (item.ImageStyle) {
                                    item.ImageStyle = JSON.parse(item.ImageStyle);
                                }
                            }
                            vm.news.push(...resp.data);

                            if (vm.firstLoad) {
                                vm.firstLoad = false;
                                if (vm.scrollTop) {
                                    $('.body-panel-content').animate({scrollTop: vm.scrollTop}, 500);
                                }
                            }
                        }
                        else{
                            vm.canBeLoaded = false;
                        }
                    }
                    UI.unblockUI('.news');
                    vm.loading = false;
                })
            },

            goToNews(id){
                this.saveFilterState();
                this.$router.push('/news/' + id);
            },

            onAddNews(){
                this.$router.push('/news/edit/0');
            },

            goToEditNews(id){
                this.$router.push('/news/edit/' + id);
            },

            onProjectChange(item){
                this.projectId = item.Id;
                this.page = 1;
                this.news = [];
                this.canBeLoaded = true;

                this.loadNext();
                this.$emit('user-updated');
            },

            saveFilterState() {
                let stateObj = {
                    projectId: this.projectId,
                    page: this.page,
                    scrollTop: this.scrollTop
                };
                sessionStorage.setItem(cacheKey, JSON.stringify(stateObj));
            },

            recoverFilterState() {
                let stateObj = JSON.parse(sessionStorage.getItem(cacheKey));
                //console.info('recoverFilterState', stateObj);
                if (stateObj) {
                    if (stateObj.projectId == this.projectId) {
                        if (stateObj.page) {
                            this.page = stateObj.page;
                        }
                        if (stateObj.scrollTop) {
                            this.scrollTop = stateObj.scrollTop;
                        }
                    }
                    this.clearFilterState();
                }
            },

            clearFilterState() {
                sessionStorage.removeItem(cacheKey);
            }

        },

        mounted(){
            let vm = this;

            vm.recoverFilterState();

            this.loadNext();

            vm.$nextTick(() => {

                $('.body-panel-content').on('scroll', function () {
                    let elem = $(this);
                    vm.scrollTop = elem.scrollTop();

                    if(!vm.loading && vm.canBeLoaded && !vm.firstLoad) {
                        if (elem[0].scrollHeight - elem.scrollTop() - 200 <= elem.outerHeight()) {
                            vm.page++;
                            vm.loadNext();
                        }
                    }
                });
            });
        },

        destroyed(){
            $('.body-panel-content').off('scroll');
        }
    }
</script>


// WEBPACK FOOTER //
// Content/src/views/News.vue